module.exports = __webpack_public_path__ + "img/sv4.87e5a9a1.svg";